import { Timezone } from './timezone';
import { PortInterface } from '../interfaces/api';
import { LatLng } from './latlng';

export class Port implements PortInterface {

    abbr: string;

    id: number;

    name: string;

    timezone: Timezone;

    location: LatLng;

    static createFromObject(object: any): Port {
        let port = new Port();
        if (object.abbr !== undefined) port.abbr = object.abbr;
        if (object.id !== undefined) port.id = object.id;
        if (object.name !== undefined) port.name = object.name;
        if (object.timezone !== undefined) port.timezone = Timezone.createFromObject(object.timezone);
        if (object.location !== undefined) port.location = LatLng.createFromObject(object.location);
        return port;
    }

    static createFromObjects(ports: any[]): Port[] {
        let objects: Port[] = [];
        for (let port of ports) {
            objects.push(Port.createFromObject(port));
        }
        return objects;
    }
}



// WEBPACK FOOTER //
// ./src/entities/port.ts